import axios from 'axios';
import { axiosPath } from '../../../routing/helpers/router';

export default () => async () => {
  axios.get(axiosPath('api_r_user_global_session_keep'));
};
